import { FunctionComponent } from 'react';

import { Heading as RadixHeading, HeadingProps } from '@radix-ui/themes';

export const Heading: FunctionComponent<HeadingProps> = (
  props: HeadingProps
) => {
  return <RadixHeading {...props} />;
};
